import merge from "deepmerge";

const getErrorCount = (obj: any) =>
  obj && typeof obj === "object"
    ? Object.values(obj).filter((o: any) => o?.error).length
    : 0;

/**
 * Clear stale error objects in advance of merge
 */
const clearError = (obj: any) =>
  Object.values(obj).forEach((value: any) => {
    if (value) {
      value.error = undefined;
    }
  });
/**
 * Combines objects at the same index in the two arrays
 */
const arrayMerge = (target: any[], source: any[], options: any) => {
  const destination = target.slice();
  source.forEach((item: any, index: number) => {
    if (typeof destination[index] === "undefined") {
      destination[index] = options.cloneUnlessOtherwiseSpecified(item, options);
    } else if (options.isMergeableObject(item)) {
      const targetErrorCount = getErrorCount(target[index]);
      const sourceErrorCount = getErrorCount(item);
      /**
       * If either the newState and prevState UiFieldMaps arrays contain errors,
       *   delete the prevState errors and let the newState win
       */
      if (sourceErrorCount || targetErrorCount) {
        /**
         * why target[index]? See the default arrayMerge here:
         * https://github.com/TehShrike/deepmerge#arraymerge-example-combine-arrays
         */
        clearError(target[index]);
      }
      destination[index] = merge(target[index], item, options);
    } else if (target.indexOf(item) === -1) {
      destination.push(item);
    }
  });
  return destination;
};

/**
 * Combines objects at the key
 */
const customMerge = () => (source: any, target: any, options: any) => {
  const sourceErrorCount = getErrorCount(source);
  /**
   * If the newState UiFieldMap object contains errors,
   *   delete the prevState errors and let the newState win
   */
  if (sourceErrorCount) {
    clearError(source);
  }
  return merge(source, target, options);
};

const defaultOptions = {
  arrayMerge,
  customMerge,
};

export default (x: any, y: any, options?: merge.Options): unknown =>
  merge(x, y, Object.assign({}, options, defaultOptions));
